import { Routes } from '@angular/router';

export const ZONES_ROUTES: Routes = [
  {
    path: 'zones',
    loadComponent: () =>
      import('./zones-list/zones-list.component')
        .then(m => m.ZonesListComponent),
  }
];
